<template>
  <div ref="accountIpRestriction" class="ip-restriction-session-main">
    <h1>Current IP Information</h1>
    <p>Your IP as it shows in our system</p>
    <h2>{{ ip }}</h2>
    <p>Your current IPV4</p>
    <!-- <ButtonFilled
      @onButtonClicked="toggleRestrict"
      :text="ipRestrict ? 'Un-Restrict Account':  'Restrict Account'"
    ></ButtonFilled> -->
  </div>
</template>

<script>
//import ButtonFilled from "../../../common/ButtonFilled";
import { handleUpdateIPRestriction } from "../../../../service/user";
export default {
  components: {
   // ButtonFilled,
  },
  computed: {
    ip() {
      return this.$store.getters["userStore/getIp"];
    },
    ipRestrict() {
      return this.$store.getters["userStore/getIpRestrict"];
    },
  },
  async mounted() {
    await this.sleep(100);
    this.$refs.accountIpRestriction.style = "transform: scale(1) !important";
  },
  methods: {
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async toggleRestrict() {
      if (this.ipRestrict) {
        await handleUpdateIPRestriction("False");
      } else {
        await handleUpdateIPRestriction("True");
      }
    },
  },
};
</script>

<style>
.ip-restriction-session-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 275px;
  max-width: 40%;
  height: 265px;
  width: 40%;
  padding: 10px;
  background: radial-gradient(100% 100% at 44.04% 0%, #26292e 0%, #1a1c1f 100%);
  box-shadow: 2px 2px 5px #000000, inset 0px 1px 3px #000000;
  border-radius: 7px;
  transform: scale(0.5);
  transition: 0.4s;
}

.ip-restriction-session-main > h1 {
  color: #e0e0e0;
  font-size: 20px;
  font-family: "OpenSans-SemiBold";
  margin-top: 10px;
}
.ip-restriction-session-main > p {
  color: #888888;
  font-size: 12px;
  font-family: "OpenSans-SemiBold";
}

.ip-restriction-session-main > p:nth-last-of-type(odd) {
  color: #888888;
  font-size: 12px;
  font-family: "OpenSans-SemiBold";
  margin-bottom: 26px;
  text-align: right;
  width: 70%;
  margin-bottom: 35px;
}

.ip-restriction-session-main > h2 {
  color: #fff;
  font-size: 42px;
  font-family: "OpenSans-SemiBold";
  margin-top: 50px;
}
</style>
